import React, { useState } from "react";

function convertNumberedList(answer) {
  let html = answer.replace(/^<div>|<\/div>$/g, "");
  const parts = html.split(/<br\s*\/?>/i);

  if (parts.length < 2 || !parts[1].trim().match(/^\d+\./)) {
    return <div dangerouslySetInnerHTML={{ __html: answer }} />;
  }

  const intro = parts[0];
  const items = parts
    .slice(1)
    .map(line => line.replace(/^\d+\.\s*/, ""))
    .filter(line => line.trim().length > 0);

  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: intro }} />
      <ul>
        {items.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

const VisaFrequentlyAsked = ({ faqData }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq">
      {faqData?.map((item, index) => (
        <div key={index} className="faq__item">
          <div className="faq__question" onClick={() => toggleFAQ(index)}>
            {item.question}
            <svg
              className={`faq__icon ${
                openIndex === index ? "faq__icon--open" : ""
              }`}
              aria-hidden="true"
            >
              <use href="/sprite.svg#icon-chevon"></use>
            </svg>
          </div>
          {openIndex === index && (
            <div className="faq__answer">
              {convertNumberedList(item.answer)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default VisaFrequentlyAsked;